import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-1ab676d1"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "Ning-tips"
};

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "Ning-title"
  }, " 答案提示 ", -1);
});

var _hoisted_3 = {
  class: "Ning-answer"
};
var _hoisted_4 = {
  key: 0,
  class: "is-right"
};

var _hoisted_5 = /*#__PURE__*/_createTextVNode(" 正确答案：");

var _hoisted_6 = {
  key: 1,
  class: "is-right"
};

var _hoisted_7 = /*#__PURE__*/_createTextVNode(" 正确答案：");

var _hoisted_8 = {
  key: 2,
  class: "is-right"
};

var _hoisted_9 = /*#__PURE__*/_createTextVNode(" 正确答案：");

var _hoisted_10 = {
  key: 3,
  class: "is-right"
};

var _hoisted_11 = /*#__PURE__*/_createTextVNode(" 正确答案：");

var _hoisted_12 = /*#__PURE__*/_createTextVNode(" 您的答案：");

var _hoisted_13 = /*#__PURE__*/_createTextVNode(" 您的答案： ");

var _hoisted_14 = {
  key: 1
};

var _hoisted_15 = /*#__PURE__*/_createTextVNode(" 您的答案：");

var _hoisted_16 = /*#__PURE__*/_createTextVNode(" 您的答案：");

var _hoisted_17 = {
  class: "Ning-analysis"
};

var _hoisted_18 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, "解析：", -1);
});

var _hoisted_19 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_ctx.istype == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", null, _toDisplayString(_ctx.alphabet[_ctx.detail.right - 1]), 1)])) : _createCommentVNode("", true), _ctx.istype == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_hoisted_7, _createElementVNode("span", null, _toDisplayString(_ctx.detail.right == 0 ? "对" : "错"), 1)])) : _createCommentVNode("", true), _ctx.istype == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_hoisted_9, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail.right.split(','), function (item, index) {
    return _openBlock(), _createElementBlock("span", {
      key: index
    }, _toDisplayString(_ctx.alphabet[item - 1]), 1);
  }), 128))])) : _createCommentVNode("", true), _ctx.istype == 4 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_hoisted_11, _createElementVNode("span", null, _toDisplayString(_ctx.detail.right), 1)])) : _createCommentVNode("", true), _ctx.istype == 1 ? (_openBlock(), _createElementBlock("div", {
    key: 4,
    class: _normalizeClass(["is-error", {
      'is-error-none': _ctx.detail.left != _ctx.detail.right
    }])
  }, [_hoisted_12, _createElementVNode("span", null, _toDisplayString(_ctx.detail.left != "" && _ctx.detail.left ? _ctx.alphabet[_ctx.detail.left - 1] : "未作答"), 1)], 2)) : _createCommentVNode("", true), _ctx.istype == 2 ? (_openBlock(), _createElementBlock("div", {
    key: 5,
    class: _normalizeClass(["is-error", {
      'is-error-none': _ctx.detail.left != _ctx.detail.right
    }])
  }, [_hoisted_13, _ctx.detail.left != '' ? (_openBlock(true), _createElementBlock(_Fragment, {
    key: 0
  }, _renderList(_ctx.detail.left.split(','), function (item, index) {
    return _openBlock(), _createElementBlock("span", {
      key: index
    }, _toDisplayString(_ctx.alphabet[item - 1]), 1);
  }), 128)) : (_openBlock(), _createElementBlock("span", _hoisted_14, "未作答"))], 2)) : _createCommentVNode("", true), _ctx.istype == 3 ? (_openBlock(), _createElementBlock("div", {
    key: 6,
    class: _normalizeClass(["is-error", {
      'is-error-none': _ctx.detail.left != _ctx.detail.right
    }])
  }, [_hoisted_15, _createElementVNode("span", null, _toDisplayString(_ctx.detail.left != "" && _ctx.detail.left ? _ctx.detail.left == 0 ? "对" : "错" : "未作答"), 1)], 2)) : _createCommentVNode("", true), _ctx.istype == 4 ? (_openBlock(), _createElementBlock("div", {
    key: 7,
    class: _normalizeClass(["is-error", {
      'is-error-none': _ctx.detail.left != _ctx.detail.right
    }])
  }, [_hoisted_16, _createElementVNode("span", null, _toDisplayString(_ctx.detail.left != "" && _ctx.detail.left ? _ctx.detail.left : "未作答"), 1)], 2)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", {
    innerHTML: _ctx.getXssIntro()
  }, null, 8, _hoisted_19)])]);
}